import { PGAdapterBuilder } from "@sia/style-guide";
import KeycloakIDPAdapter from "../IDPAdapter/KeycloakIDPAdapter";

const apiUrl = process.env.REACT_APP_BENCHMARKING_SERVICE_URL;

const PGAdapter = PGAdapterBuilder(KeycloakIDPAdapter, apiUrl);
export default PGAdapter;
